import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

// Import environment
import { environment } from 'src/environments/environment';
import { Store } from '@ngrx/store';

@Injectable({
  providedIn: 'root'
})
export class ResetPasswordService {

  constructor(private http: HttpClient) { }

  resetPasswordApi = (payload: any) => {
    return this.http.post(environment.userApiUrl + 'api/admin/resetPassword', payload)
  }

}
